export const typography = {
  margin: 'none',
  letterSpacing: '0.5px',
  variants: {
    special: {
      fontSize: 'xxxl',
      lineHeight: 'xxxl',
      fontFamily: 'regular',
      fontWeight: '700',
      color: 'primary/text',
      mb: 'none',
    },
    h1: {
      fontSize: 'xxl',
      lineHeight: 'xxl',
      fontFamily: 'regular',
      fontWeight: '500',
      color: 'primary/text',
      mb: 'none',
    },
    h2: {
      fontSize: 'xl',
      lineHeight: 'xl',
      fontFamily: 'regular',
      fontWeight: '400',
      color: 'primary/text',
      mb: 'none',
    },
    'h2/light': {
      fontSize: 'xl',
      lineHeight: 'xl',
      fontFamily: 'regular',
      fontWeight: '400',
      color: 'grey/light',
      mb: 'none',
    },
    h3: {
      fontSize: 'l',
      lineHeight: 'l',
      fontFamily: 'regular',
      fontWeight: '400',
      color: 'primary/text',
      mb: 'none',
    },
    h4: {
      fontSize: 'm',
      lineHeight: 'm',
      fontFamily: 'regular',
      fontWeight: '400',
      color: 'primary/text',
      mb: 'none',
    },
    'h4/book': {
      fontSize: 'm',
      lineHeight: 'm',
      fontFamily: 'regular',
      fontWeight: '400',
      color: 'primary/text',
      mb: 'none',
    },
    p1: {
      fontSize: 'm',
      lineHeight: 'm',
      fontFamily: 'regular',
      fontWeight: '400',
      color: 'primary/text',
      mb: 'none',
    },
    'p1/bold': {
      fontSize: 'm',
      lineHeight: 'm',
      fontFamily: 'regular',
      fontWeight: '700',
      color: 'primary/text',
      mb: 'none',
    },
    'p1/light': {
      fontSize: 'm',
      lineHeight: 'm',
      fontFamily: 'regular',
      fontWeight: '300',
      color: 'primary/text',
      mb: 'none',
    },
    p2: {
      fontSize: 's',
      lineHeight: 's',
      fontFamily: 'regular',
      fontWeight: '400',
      color: 'primary/text',
      mb: 'none',
    },
    'p2/bold': {
      fontSize: 's',
      lineHeight: 's',
      fontFamily: 'regular',
      fontWeight: '700',
      color: 'primary/text',
      mb: 'none',
    },
    'p2/light': {
      fontSize: 's',
      lineHeight: 's',
      fontFamily: 'regular',
      fontWeight: '300',
      color: 'primary/text',
      mb: 'none',
    },
    'p2/label': {
      fontSize: 's',
      lineHeight: 's',
      fontFamily: 'regular',
      fontWeight: '600',
      color: 'primary/text',
    },
    'p3/light': {
      fontSize: 's',
      lineHeight: 's',
      fontFamily: 'regular',
      fontWeight: '300',
      color: 'grey/light',
    },
    'p3/label': {
      fontSize: 'xs',
      lineHeight: 's',
      fontFamily: 'regular',
      fontWeight: '700',
      color: 'grey/light',
    },
  },
};
